module.exports = __webpack_public_path__ + "img/icon-arrow-circle.197f7e53.svg";